import countries from "assets/rawData/countries.json";
import states from "assets/rawData/states.json";
import cities from "assets/rawData/cities.json";

import { func_validation } from "./func_validation";

export const func_data = {
    getAllCountries,
    getAllStates,
    getAllCities,

    getCountryFromISOCode,
    getStatesFromCountryId,
    getCitiesFromStateId,
}

function getAllCountries() {
    return countries;
}

function getAllStates() {
    return states;
}

function getAllCities() {
    return cities;
}

function getCountryFromISOCode(isoCode, defaultVal) {
    if (func_validation.isStringTrimNotEmpty(isoCode)) {
        let countries = getAllCountries();
        for (let i = 0; i < countries.length; i++) {
            let isoCode_fromList = countries[i].sortname;
            if (func_validation.isStringEqual_caseInsensitive(isoCode, isoCode_fromList)) {
                return countries[i];
            }
        }
    }
    else if (func_validation.isNotNullUndefined(defaultVal)) {
        return defaultVal;
    }
    else return undefined;
}

function getStatesFromCountryId(countryId, defaultVal) {
    if (func_validation.isNumberValid(countryId)) {
        let states = getAllStates();
        let filteredStates = [];
        for (let i = 0; i < states.length; i++) {
            let countryId_fromList = states[i].country_id;
            if (func_validation.isNumberWithinRange(countryId, { equal: countryId_fromList })) {
                filteredStates.push(states[i]);
            }
        }

        return filteredStates;
    }
    else if (func_validation.isNotNullUndefined(defaultVal)) {
        return defaultVal;
    }
    else return undefined;
}

function getCitiesFromStateId(stateId, defaultVal) {
    if (func_validation.isNumberValid(stateId)) {
        let cities = getAllCities();
        let filteredCities = [];
        for (let i = 0; i < cities.length; i++) {
            let stateId_fromList = cities[i].state_id;
            if (func_validation.isNumberWithinRange(stateId, { equal: stateId_fromList })) {
                filteredCities.push(cities[i]);
            }
        }

        return filteredCities;
    }
    else if (func_validation.isNotNullUndefined(defaultVal)) {
        return defaultVal;
    }
    else return undefined;
}